import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const ContactUs = () => {
  const contactInfo = [
    {
      icon: Mail,
      title: "Email",
      value: "info@itdesks.co",
      href: "mailto:info@itdesks.co"
    },
    {
      icon: Phone,
      title: "Phone",
      value: "+1 (510) 520-7318",
      href: "tel:+15105207318"
    },
    {
      icon: MapPin,
      title: "Address",
      value: "Houston, TX, 77493, US",
      href: "https://www.google.com/maps?q=Houston,+TX+77493,+USA"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 py-16 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Contact Us
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Get in touch with us. We'd love to hear from you and will respond as soon as possible.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {contactInfo.map((item, index) => (
            <a
              key={index}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 group cursor-pointer hover:-translate-y-1"
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-blue-200 transition-colors duration-300">
                  <item.icon className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-600 group-hover:text-blue-600 transition-colors duration-300">
                  {item.value}
                </p>
              </div>
            </a>
          ))}
        </div>

        {/* Map Section */}
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:scale-[1.01] transition-transform duration-300">
          <div className="p-6 bg-gradient-to-r from-blue-600 to-blue-700">
            <h2 className="text-2xl font-bold text-white mb-2">Find Us</h2>
            <p className="text-blue-100">Visit us in Houston, TX</p>
          </div>

          <div className="relative h-96 md:h-[500px]">
            <iframe
              src="https://www.google.com/maps?q=Houston,+TX+77493,+USA&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="absolute inset-0"
              title="Houston, TX 77493 Location"
            ></iframe>

            {/* Custom overlay */}
            <div className="absolute inset-0 bg-blue-600 opacity-0 hover:opacity-10 pointer-events-none transition-opacity duration-300" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
